import type { Translation } from "./types";

const zh: Translation = {
  home: {
    title: "AI我的兄弟",
    subtitle: "是时候构建了！",
  },
  about: {
    link: "关于我们",
    title: "关于我们",
    subtitle: "AI我的兄弟背后的团队与承诺",
  },
  navigation: {
    en: "英语",
    kr: "韩语",
    es: "西班牙语",
    zh: "中文",
  },
  menu: {
    explain: "解释",
    chat: "聊天",
    quiz: "测验",
    progress: "进度",
  },
  auth: {
    login: {
      title: "登录您的账户",
      subtitle: "请输入您的详细信息",
      email: "邮箱",
      password: "密码",
      forgotPassword: "忘记密码？",
      loginButton: "登录",
      emailNotConfirmed: "邮箱未确认",
      resendConfirmation: "重新发送确认邮件",
      noAccount: "没有账户？",
      signUp: "注册",
      emailPlaceholder: "example@email.com",
      passwordPlaceholder: "请输入密码",
    },
    join: {
      title: "创建账户",
      subtitle: "请输入详细信息以创建账户",
      name: "姓名",
      email: "邮箱",
      password: "密码",
      confirmPassword: "确认密码",
      marketingConsent: "订阅营销邮件",
      termsAgreement: "我已阅读并同意服务条款和隐私政策",
      termsOfService: "服务条款",
      privacyPolicy: "隐私政策",
      createAccount: "创建账户",
      accountCreated: "账户已创建！",
      emailVerificationRequired: "需要邮箱验证。请检查您的邮箱。",
      alreadyHaveAccount: "已有账户？",
      signIn: "登录",
      namePlaceholder: "张三",
      emailPlaceholder: "example@email.com",
      passwordHint: "至少需要8个字符。",
      passwordPlaceholder: "请输入密码",
      confirmPasswordPlaceholder: "请再次输入密码",
      and: "和",
      agreeTo: "。",
    },
    forgotPassword: {
      title: "忘记密码？",
      subtitle: "输入您的邮箱，我们将向您发送重置链接。",
      email: "邮箱",
      emailPlaceholder: "example@email.com",
      sendButton: "发送重置链接",
      successMessage: "请检查您的邮箱以获取重置链接，您可以关闭此标签页。",
    },
    newPassword: {
      title: "更新您的密码",
      subtitle: "输入您的新密码并确认。",
      password: "密码",
      confirmPassword: "确认密码",
      passwordPlaceholder: "输入您的新密码",
      confirmPasswordPlaceholder: "确认您的新密码",
      updateButton: "更新密码",
      successMessage: "密码更新成功！",
      passwordsMatchError: "密码必须匹配",
      redirectMessage: "{{seconds}}秒后跳转到登录页面...",
      goToLogin: "前往登录",
    },
  },
  landing: {
    hero: {
      quote: "以最不受约束、最不敬和最原创的方式研究您最感兴趣的领域",
      author: "Richard Feynman",
    },
    intro: {
      title: "与AI我的兄弟一起自主学习",
      subtitle: "解释得越多，您就越聪明。AI兄弟给您可爱而敏锐的反馈。",
      features: {
        organize: "整理想法",
        practice: "练习解释",
        learning: "深度学习",
      },
      cta: "开始教AI兄弟",
    },
    examples: {
      title: "人们是这样解释的！",
      physics: {
        user: "重力是让物体下落的力",
        ai: "对！苹果也掉到地上了 🍎 但为什么月亮不掉下来呢？",
      },
      biology: {
        user: "光合作用是植物利用光制造食物的过程",
        ai: "哇！🌱 所以植物就像厨师一样！它们需要什么原料呢？",
      },
      politics: {
        user: "民主是人民治理国家",
        ai: "酷！🗳️ 那么任何人都可以成为总统吗？",
      },
    },
    footer: {
      description:
        "AI我的兄弟是您可靠的学习伙伴，帮助您培养通过语言组织知识的能力。",
    },
  },
  contact: {
    title: "联系我们",
    subtitle: "有任何问题吗？随时联系我们。我们会尽快回复您。",
    form: {
      name: "姓名",
      email: "邮箱",
      message: "消息",
      namePlaceholder: "请输入您的姓名",
      emailPlaceholder: "请输入您的邮箱",
      messagePlaceholder: "请输入您的消息",
      sendButton: "发送",
      captchaNote: "使用Cloudflare Turnstile增强安全性和用户体验。",
    },
    messages: {
      success: "消息发送成功",
      error: "发送消息时发生错误",
      captchaError: "安全验证失败。请重试。",
    },
  },
  legal: {
    privacyPolicy: "隐私政策",
    termsOfService: "服务条款",
    youthPolicy: "青少年保护政策",
    cookiePolicy: "Cookie 政策",
  },
  settings: {
    profile: {
      title: "个人资料编辑功能（暂时禁用）",
      subtitle: "您可以查看您的个人资料信息。",
      name: "姓名",
    },
    name: {
      title: "更改姓名",
      subtitle: "更改您的显示姓名。",
      currentName: "当前姓名",
      newName: "新姓名",
      namePlaceholder: "请输入新姓名",
      changeButton: "更改姓名",
      successMessage: "姓名更改成功",
    },
    email: {
      title: "更改邮箱",
      titleAdd: "添加邮箱",
      subtitle: "更改您的邮箱地址。",
      subtitleAdd: "为您的账户添加邮箱地址。",
      currentEmail: "当前邮箱",
      newEmail: "新邮箱",
      changeButton: "更改邮箱",
      addButton: "添加邮箱",
      successMessage: "邮箱更新过程已开始。请检查您的旧邮箱以获取验证链接。",
    },
    password: {
      title: "更改密码",
      titleAdd: "添加密码",
      subtitle: "更改您的密码。",
      subtitleAdd: "为您的账户添加密码。",
      newPassword: "新密码",
      confirmPassword: "确认新密码",
      changeButton: "更改密码",
      addButton: "添加密码",
      successMessage: "密码已更新",
    },
    social: {
      title: "连接社交账户",
      subtitle: "为您的账户添加或删除其他身份验证方法。",
    },
    danger: {
      title: "危险区域",
      confirmDelete: "我确认要删除我的账户。",
      confirmIrreversible: "我理解此操作不可逆转。",
      deleteButton: "删除账户",
    },
  },
  error: {
    title: "错误",
    errorCode: "错误代码",
    goHome: "返回主页",
    otpExpired: "邮箱链接无效或已过期",
    invalidLink: "邮箱链接已过期或已被使用。请重新请求密码重置。",
  },
  common: {
    beta: "测试版",
    betaNotice: "此服务目前处于测试阶段。如果您遇到任何问题，请向我们提供反馈。",
  },
};

export default zh;
